import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { useBlogPost } from 'client/store'
import { blogPostSelectors } from 'client/store/blogPost/blogPostReducer'
import { EntityProps } from 'client/types'
import CommonBreadcrumbs from 'common/components/entities/Breadcrumbs'
import {
  Breadcrumb,
  BreadcrumbsInterface,
} from 'common/types/entities/BreadcrumbsInterface'
import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

function Breadcrumbs({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BreadcrumbsInterface>) {
  const { t } = useTypedTranslation('common')
  const categories = useBlogPost(blogPostSelectors.getBlogPostCategories) || []
  const title = useBlogPost(blogPostSelectors.getBlogPostTitle)
  const breadcrumbs: Breadcrumb[] = [
    { name: t('components.breadcrumbs.items.home'), url: '' },
  ]

  if (categories.length > 0) {
    breadcrumbs.push({
      name: categories[0],
      url: '',
    })
  }
  breadcrumbs.push({ name: title })

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonBreadcrumbs
        items={breadcrumbs}
        itemColor={entity.itemColor}
        lastItemColor={entity.lastItemColor}
        fontSize={entity.fontSize}
        fontStyle={entity.fontStyle}
        fontWeight={entity.fontWeight}
        fontFamily={entity.fontFamily}
        mobileFontSize={entity.mobileFontSize}
        mobileFontStyle={entity.mobileFontStyle}
        mobileFontWeight={entity.mobileFontWeight}
        mobileFontFamily={entity.mobileFontFamily}
      />
    </BaseEntityNew>
  )
}

export function getBreadcrumbsFontProperties(entity: BreadcrumbsInterface) {
  const fontProperties = entity.fontFamily
    ? [
        {
          fontFamily: entity.fontFamily,
          fontStyle: entity.fontStyle,
          fontWeight: entity.fontWeight,
        },
      ]
    : []

  if (entity.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileFontFamily,
      fontStyle: entity.mobileFontStyle,
      fontWeight: entity.mobileFontWeight,
    })
  }

  return fontProperties
}

export default Breadcrumbs
